/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./OtherSourcesDownload.vue?vue&type=template&id=09d615c3&scoped=true&"
import script from "./OtherSourcesDownload.vue?vue&type=script&lang=js&"
export * from "./OtherSourcesDownload.vue?vue&type=script&lang=js&"
import style0 from "./OtherSourcesDownload.vue?vue&type=style&index=0&id=09d615c3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d615c3",
  null
  
)

export default component.exports